export const validateSnils = (value: string): boolean => {
  if (!value || value === '___-___-___ __') return true;
  const [number, checkSum] = value.split(' ');
  const full = number.replace(/[-_]/g, '');
  if (full.length !== 9) return false;

  const fullNum = parseInt(full);
  if (fullNum < 1001999) return false;

  const checkSumNum = parseInt(checkSum);
  let sum = 0;
  const len = full.length;
  for (let i = 0; i < len; i++) {
    sum += parseInt(full[i]) * (len - i);
  }

  if (sum < 100) return checkSumNum === sum;
  if (sum === 100 || sum === 101) return checkSumNum === 0;
  if (sum > 101) return checkSumNum === sum % 101;

  return false;
};



// WEBPACK FOOTER //
// ./src/tools/validateSnils.ts